import { videoModalActionTypes } from '@/components/modals/videoModal/Constants';

import type { ToggleVideoModalAction, VideoModalActions, VideoModalState } from './types';

const initialState: VideoModalState = {
	open: false,
	videoId: null,
	onClose: null,
	autoplay: false,
};

export default function videoModalReducer(
	state = initialState,
	action: VideoModalActions,
): VideoModalState {
	switch (action.type) {
		case videoModalActionTypes.TOGGLE_VIDEO_MODAL: {
			const { data } = (action as ToggleVideoModalAction).payload;
			return {
				...state,
				...data,
			};
		}

		default:
			return state;
	}
}
